// Layer 2 (Engine): the manager's escalation decisions recorded this session
// (komatsu.K12e #647, ADOPT #5). Each escalation card on the GM landing closes
// with a `Record decision` gate; recording stamps the chosen decision, the
// seat holder and the cursor time. A record is written once and never
// overwritten, like the case page's action decisions. The state is held by
// `EscalationDecisionProvider` at the app root beside `AdvisoryProvider`, so a
// record survives leaving the landing (to Advisory, and back by the sidebar);
// only a reload resets it.

import type { Persona } from '@/shared/types';
import type { SeriesTime } from '@/versions/v1/schema/reading-series';

export type EscalationDecisionRecord = {
  cardId: string;
  decision: string;
  recordedAt: SeriesTime;
  recordedBy: Persona;
};

export type EscalationDecisionState = ReadonlyMap<string, EscalationDecisionRecord>;

export const INITIAL_ESCALATION_DECISIONS: EscalationDecisionState = new Map();

/** Returns the state with the record added; a card already recorded keeps its first record. */
export function recordEscalationDecision(
  state: EscalationDecisionState,
  record: EscalationDecisionRecord,
): EscalationDecisionState {
  if (state.has(record.cardId)) return state;
  const next = new Map(state);
  next.set(record.cardId, record);
  return next;
}

/** The ids of the escalation cards already recorded. */
export function recordedEscalationIds(state: EscalationDecisionState): ReadonlySet<string> {
  return new Set(state.keys());
}
